import { createSelector } from 'reselect'

export const selectStaff = state => state?.staff

export const selectedStaffData = createSelector([selectStaff], staff => {
  const { searchstaff, userInfodata } = staff
  if (searchstaff && userInfodata) {
    return userInfodata.filter(
      r =>
        r?.business_name?.toLowerCase().includes(searchstaff.toLowerCase()) ||
        r?.contact_name?.toLowerCase().includes(searchstaff.toLowerCase()) ||
        r?.emailid?.toLowerCase().includes(searchstaff.toLowerCase()),
    )
  }
  return userInfodata
})
